import { Card } from '@splitfiesta/ui';

import {
  Skeleton,
  SkeletonButton,
  SkeletonText,
  SkeletonTitle,
} from './SkeletonComponents';

export function GroupsPageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-6 sm:space-y-8">
      {/* Header with Action Buttons */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="flex-1 min-w-0">
          <SkeletonTitle className="w-40 h-8 sm:h-9 mb-2" />
          <SkeletonText className="w-48 sm:w-64" />
        </div>
        <div className="shrink-0">
          <SkeletonButton className="w-full sm:w-32 h-10" />
        </div>
      </div>

      {/* Search Bar */}
      <div className="max-w-md">
        <Skeleton className="w-full h-10 rounded-lg" />
      </div>

      {/* Groups List - Matches GroupsTable structure exactly */}
      <Card className="overflow-hidden">
        <div className="-mx-6">
          {[1, 2, 3, 4, 5].map(i => (
            <div
              key={i}
              className={`py-3 sm:py-4 flex items-center justify-between gap-3 sm:gap-4 px-4 sm:px-6 ${
                i !== 5 ? 'border-b border-gray-100 dark:border-gray-700' : ''
              }`}
            >
              {/* Left side: Icon and Group Info */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                {/* Group icon - matches w-7 h-7 sm:w-8 sm:h-8 */}
                <Skeleton className="w-7 h-7 sm:w-8 sm:h-8 rounded-sm shrink-0" />
                <div className="flex-1 min-w-0">
                  {/* Group name */}
                  <Skeleton className="h-4 sm:h-5 w-24 sm:w-32 mb-1" />
                  {/* Description (optional, shown on some) */}
                  {i % 2 === 0 && (
                    <Skeleton className="h-3 w-32 sm:w-48 mb-1" />
                  )}
                  {/* Member count and last activity */}
                  <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-3 mt-0.5 sm:mt-1">
                    <Skeleton className="h-3 w-16 sm:w-20" />
                    <Skeleton className="hidden sm:block h-3 w-1" />
                    <Skeleton className="h-3 w-14 sm:w-16" />
                  </div>
                </div>
              </div>

              {/* Right side: Currency badge and balance */}
              <div className="text-right shrink-0">
                {/* Currency badge and owner badge row */}
                <div className="flex items-center justify-end gap-1 mb-0.5">
                  <Skeleton className="w-8 h-4 rounded-sm" />
                  {i === 1 && <Skeleton className="w-14 h-5 rounded-sm" />}
                </div>
                {/* Balance amount */}
                <Skeleton className="h-5 sm:h-6 w-16 sm:w-20 ml-auto mb-0.5" />
                {/* You owe/owed text */}
                <Skeleton className="h-3 w-12 sm:w-14 ml-auto" />
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
